// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","pageContent":"_1ZU0q","closeIcon":"_2Cy8M"};